import React from 'react';
import PropTypes from "prop-types";
import classnames from "classnames";

import 'apps/QuoterApp/components/QuoterLayout/styles.scss';


const LEFT_BAR_TYPE = 'LeftBar';
const CONTENT_TYPE = 'Content';
const RIGHT_TYPE = 'RightBar';


function QuoterLayout({children, className, ...props}) {
    const childrenList = React.Children.toArray(children);
    const leftBar = childrenList.find(child => child.props.__TYPE === LEFT_BAR_TYPE);
    const content = childrenList.find(child => child.props.__TYPE === CONTENT_TYPE);
    const rightBar = childrenList.find(child => child.props.__TYPE === RIGHT_TYPE);

    return <div className={classnames("QuoterLayout", className)} {...props}>
        {leftBar}
        {content}
        {rightBar}
    </div>;
}

function generateChild(type) {
    const child = ({children, className, ...props}) =>
        <div className={classnames(`QuoterLayout__${type}`, className)} {...props}>
            {children}
        </div>;

    child.propTypes = {
        children: PropTypes.node,
        __TYPE: PropTypes.oneOf([type]),
    };
    child.defaultProps = {__TYPE: type};

    return child;
}

QuoterLayout.LeftBar = generateChild(LEFT_BAR_TYPE);
QuoterLayout.RightBar = generateChild(RIGHT_TYPE);

const Content = ({children, className, ...props}) =>
    <div className={'QuoterLayout__Content'}>
        <div className={classnames('QuoterLayout__Content__Scroll', className)} {...props}>
            {children}
        </div>
    </div>;

Content.propTypes = {
    children: PropTypes.node,
    __TYPE: PropTypes.oneOf([CONTENT_TYPE]),
};
Content.defaultProps = {__TYPE: CONTENT_TYPE};

QuoterLayout.Content = Content;


QuoterLayout.propTypes = {
    children: PropTypes.node,
};

export default QuoterLayout;
